module.exports = __webpack_public_path__ + "static/media/search.0e8c8601.svg";